/* eslint-disable */
// @ts-nocheck
import { useCallback, useState } from 'react';
import { applyEdgeChanges, applyNodeChanges, Background, Controls, ReactFlow } from '@xyflow/react';
import '@xyflow/react/dist/style.css';

const initialNodes = [
  {
    x: 160,
    y: 54.5,
    id: '1',
    data: {
      name: 'Start',
      prompt:
        'Greet the Napa Auto Parts employee and explain that you are calling to inquire about battery prices for a 1994 Chevy Silverado.',
      isStart: true,
      globalPrompt:
        'This is a phone call. Do not use exclamation marks.\n\nConvert 24HR format timings to 12 HR format - e.g 14:00 should be written as 2 PM. ',
      modelOptions: {
        modelType: 'smart',
        temperature: 0.2,
        skipUserResponse: false,
        block_interruptions: false,
      },
    },
    type: 'Default',
    width: 320,
    height: 127,
    dragging: false,
    position: {
      x: 160,
      y: 54.5,
    },
    selected: false,
    positionAbsolute: {
      x: 0,
      y: 0,
    },
  },
  {
    x: 160,
    y: 263.5,
    id: '2794f700-3732-4834-be3c-aae135650bdb',
    data: {
      name: 'Provide Vehicle Details',
      prompt:
        'Provide the employee with the necessary details about the 1994 Chevy Silverado, such as the engine size, trim level, or any other relevant information they need to look up the correct battery.',
      globalPrompt:
        'This is a phone call. Do not use exclamation marks.\n\nConvert 24HR format timings to 12 HR format - e.g 14:00 should be written as 2 PM. ',
      modelOptions: {
        modelType: 'smart',
        temperature: 0.2,
        skipUserResponse: false,
        block_interruptions: false,
      },
    },
    type: 'Default',
    width: 320,
    height: 127,
    dragging: false,
    position: {
      x: 160,
      y: 263.5,
    },
    selected: false,
    positionAbsolute: {
      x: 0,
      y: 0,
    },
  },
  {
    x: 160,
    y: 472.5,
    id: '755afb81-aab8-426a-b88f-dd34f5e8e5a3',
    data: {
      name: 'Receive Pricing Information',
      prompt:
        'Thank the employee for providing the pricing information. Ask if there are any additional fees or taxes that would be added to the quoted price.',
      globalPrompt:
        'This is a phone call. Do not use exclamation marks.\n\nConvert 24HR format timings to 12 HR format - e.g 14:00 should be written as 2 PM. ',
      modelOptions: {
        modelType: 'smart',
        temperature: 0.2,
        skipUserResponse: false,
        block_interruptions: false,
      },
    },
    type: 'Default',
    width: 320,
    height: 127,
    dragging: false,
    position: {
      x: 160,
      y: 472.5,
    },
    selected: false,
    positionAbsolute: {
      x: 0,
      y: 0,
    },
  },
  {
    x: 160,
    y: 681.5,
    id: 'cfae3244-ce85-4385-9104-7a9dff52ea11',
    data: {
      name: 'Confirm Total Cost',
      prompt:
        'Confirm the total cost of the battery, including any additional fees or taxes mentioned by the employee.',
      globalPrompt:
        'This is a phone call. Do not use exclamation marks.\n\nConvert 24HR format timings to 12 HR format - e.g 14:00 should be written as 2 PM. ',
      modelOptions: {
        modelType: 'smart',
        temperature: 0.2,
        skipUserResponse: false,
        block_interruptions: false,
      },
    },
    type: 'Default',
    width: 320,
    height: 127,
    dragging: false,
    position: {
      x: 160,
      y: 681.5,
    },
    selected: false,
    positionAbsolute: {
      x: 0,
      y: 0,
    },
  },
  {
    x: 160,
    y: 890.5,
    id: '69791e0d-0f24-4319-972e-36694e55c0d6',
    data: {
      name: 'End Call',
      prompt:
        'Thank the employee for their assistance and let them know you will consider the quoted price for the battery.',
      globalPrompt:
        'This is a phone call. Do not use exclamation marks.\n\nConvert 24HR format timings to 12 HR format - e.g 14:00 should be written as 2 PM. ',
      modelOptions: {
        modelType: 'smart',
        temperature: 0.2,
        skipUserResponse: false,
        block_interruptions: false,
      },
    },
    type: 'End Call',
    width: 320,
    height: 127,
    dragging: false,
    position: {
      x: 160,
      y: 890.5,
    },
    selected: false,
    positionAbsolute: {
      x: 0,
      y: 0,
    },
  },
  {
    id: '95dddc9d-5acb-45f3-bed5-efc06684eb22',
    data: {
      name: 'New Amazon Connect Node',
      prompt: 'Placeholder instructions for agent to say',
      globalPrompt:
        'This is a phone call. Do not use exclamation marks.\n\nConvert 24HR format timings to 12 HR format - e.g 14:00 should be written as 2 PM. ',
    },
    type: 'Amazon Connect',
    width: 320,
    height: 109,
    dragging: false,
    position: {
      x: 599.5232241681125,
      y: 429.3304009392418,
    },
    selected: false,
    positionAbsolute: {
      x: 599.5232241681125,
      y: 429.3304009392418,
    },
  },
  {
    id: '07f3f331-fb74-4ac6-856c-bd0f700fd1ed',
    data: {
      name: 'New Vector DB Knowledge Base Node',
      prompt: 'Placeholder instructions for agent to say',
      globalPrompt:
        'This is a phone call. Do not use exclamation marks.\n\nConvert 24HR format timings to 12 HR format - e.g 14:00 should be written as 2 PM. ',
    },
    type: 'Vector DB Knowledge Base',
    width: 320,
    height: 109,
    dragging: false,
    position: {
      x: 324.6556944314424,
      y: 486.24021318736584,
    },
    selected: false,
  },
  {
    id: 'd466c4ce-e902-40df-8fb7-7be1c4ef4db4',
    data: {
      name: 'New Transfer Pathway Node',
      prompt: 'Placeholder instructions for agent to say',
      globalPrompt:
        'This is a phone call. Do not use exclamation marks.\n\nConvert 24HR format timings to 12 HR format - e.g 14:00 should be written as 2 PM. ',
    },
    type: 'Transfer Pathway',
    width: 320,
    height: 225,
    dragging: false,
    position: {
      x: 143.39319443144234,
      y: 56.96699890165141,
    },
    selected: false,
    positionAbsolute: {
      x: 143.39319443144234,
      y: 56.96699890165141,
    },
  },
  {
    id: '56c835c6-1601-4844-931c-8b6350fc387f',
    data: {
      name: 'New SMS Node',
      prompt: 'Placeholder instructions for agent to say',
      globalPrompt:
        'This is a phone call. Do not use exclamation marks.\n\nConvert 24HR format timings to 12 HR format - e.g 14:00 should be written as 2 PM. ',
    },
    type: 'SMS',
    width: 320,
    height: 127,
    dragging: false,
    position: {
      x: 489.7616120840562,
      y: 486,
    },
    selected: false,
  },
  {
    id: '65484557-1eb8-4b3f-a1c6-7cbb18e86add',
    data: {
      name: 'New Press Button Node',
      prompt: 'Placeholder instructions for agent to say',
      globalPrompt:
        'This is a phone call. Do not use exclamation marks.\n\nConvert 24HR format timings to 12 HR format - e.g 14:00 should be written as 2 PM. ',
    },
    type: 'Press Button',
    width: 320,
    height: 137,
    position: {
      x: 499.7616120840562,
      y: 496,
    },
    selected: false,
  },
  {
    id: '893620c1-4705-4a75-945f-45a795a454a1',
    data: {
      name: 'New Default Node',
      prompt: 'Placeholder instructions for agent to say',
      globalPrompt:
        'This is a phone call. Do not use exclamation marks.\n\nConvert 24HR format timings to 12 HR format - e.g 14:00 should be written as 2 PM. ',
    },
    type: 'Default',
    position: {
      x: 481.4582092997774,
      y: 486,
    },
    selected: false,
  },
];

const initialEdges = [
  {
    id: 'reactflow__edge-1-Provide Vehicle Details',
    data: {
      label: 'Employee asks for more details',
      description:
        'If the employee needs more information about the vehicle or battery specifications, provide the relevant details.',
    },
    type: 'custom',
    source: '1',
    target: '2794f700-3732-4834-be3c-aae135650bdb',
    animated: true,
    selected: false,
    sourceHandle: null,
    targetHandle: null,
  },
  {
    id: 'reactflow__edge-2794f700-3732-4834-be3c-aae135650bdb-Receive Pricing Information',
    data: {
      label: 'Employee provides pricing information',
      description: 'If the employee provides pricing information for the battery, proceed to the next node.',
    },
    type: 'custom',
    source: '2794f700-3732-4834-be3c-aae135650bdb',
    target: '755afb81-aab8-426a-b88f-dd34f5e8e5a3',
    animated: true,
    selected: false,
    sourceHandle: null,
    targetHandle: null,
  },
  {
    id: 'reactflow__edge-755afb81-aab8-426a-b88f-dd34f5e8e5a3-Confirm Total Cost',
    data: {
      label: 'No additional fees/taxes',
      description: 'If there are no additional fees or taxes, proceed to the next node.',
    },
    type: 'custom',
    source: '755afb81-aab8-426a-b88f-dd34f5e8e5a3',
    target: 'cfae3244-ce85-4385-9104-7a9dff52ea11',
    animated: true,
    selected: false,
    sourceHandle: null,
    targetHandle: null,
  },
  {
    id: 'reactflow__edge-cfae3244-ce85-4385-9104-7a9dff52ea11-End Call',
    data: {
      label: 'Employee confirms total cost',
      description: 'If the employee confirms the total cost, proceed to the next node.',
    },
    type: 'custom',
    source: 'cfae3244-ce85-4385-9104-7a9dff52ea11',
    target: '69791e0d-0f24-4319-972e-36694e55c0d6',
    animated: true,
    selected: false,
    sourceHandle: null,
    targetHandle: null,
  },
];

const PathwayBuilder = () => {
  const [nodes, setNodes] = useState(initialNodes);
  const [edges, setEdges] = useState(initialEdges);

  const onNodesChange = useCallback((changes) => setNodes((nds) => applyNodeChanges(changes, nds)), []);
  const onEdgesChange = useCallback((changes) => setEdges((eds) => applyEdgeChanges(changes, eds)), []);

  return (
    <div className="relative">
      <div style={{ width: '100vw', height: '100vh' }}>
        <ReactFlow nodes={nodes} onNodesChange={onNodesChange} edges={edges} onEdgesChange={onEdgesChange} fitView>
          <Background />
          <Controls />
        </ReactFlow>
      </div>
    </div>
  );
};

export default PathwayBuilder;
